angular.module('archie.core').factory('SnowplowService', SnowplowService);
function SnowplowService($rootScope, FacetService, SearchUtil, snowplowUtilsService, $location, deviceDetector, mappings) {
    const delimiter = '|';
    return {
        searchPageView: searchPageView,
        libraryPageView: libraryPageView,
        dialogueSearch: dialogueSearch,
        videoView: videoView,
        videoError: videoError,
        logFacetSearch: logFacetSearch,
    };
    function getUrlPath() {
        const path = $location.path();
        return $location.path().substr(0, path.lastIndexOf('/'));
    }
    function logSnowplowDialogueSearch(searchText) {
        snowplowUtilsService.trackComponent('Text Input', // Component type
        'Dialogue Search Input', // Component name
        'Search By', // Action Name
        'Dialogue Search Input', // label
        {
            value: [
                {
                    searchText: searchText, // prop3
                },
            ],
        });
    }
    function dialogueSearch(searchText) {
        const searchTextNormalized = searchText.replace(/%20/g, ' ');
        logSnowplowDialogueSearch(searchTextNormalized);
    }
    function getFacets() {
        const filters = {};
        const facetCategories = [];
        const facetsByType = {};
        //loop through facet map properties (corresponds to facet categories)
        angular.forEach(mappings.asset, (assetMap) => {
            if (!!assetMap.tracked) {
                const facet = FacetService.getFacetByFacetName(assetMap.label);
                const selectedOptions = [];
                if (facet && facet.selectedOptions && facet.selectedOptions.length) {
                    // loop through selected facets within this category
                    // and save them to selectedOptions array
                    angular.forEach(facet.selectedOptions, function (option) {
                        selectedOptions.push(option.optionName.replace(delimiter, ''));
                    });
                    facetsByType[assetMap.label] = selectedOptions;
                }
                if (selectedOptions.length) {
                    facetCategories.push(assetMap.label);
                }
            }
        });
        if (facetCategories.length) {
            filters.facetTypes = facetCategories;
            filters.facetsByType = facetsByType;
        }
        return filters;
    }
    function logFacetSearch() {
        const { facetTypes, facetsByType } = getFacets();
        if (!facetTypes || !facetsByType || $rootScope.isEntryPage) {
            return;
        }
        snowplowUtilsService.trackComponent('Checkbox List', // Component type
        'Facets', // Component name
        'Search By', // Action Name
        'Facets', // label
        {
            value: [
                {
                    facetTypes: facetTypes,
                    facetsByType: facetsByType, // prop4...prop12, prop15, prop16: { [key: string]: Array<string> }
                },
            ],
        });
    }
    function getSearchPageProps() {
        return {
            pageName: $location.url().replace(/%20/g, ' '),
            pageURL: $location.absUrl(),
            pageType: 'search',
            pageTypeAlt: 'SEARCH',
        };
    }
    function logSnowplowSearchCriteria(filters) {
        snowplowUtilsService.trackComponent('Page', // Component type
        'Search Page', // Component name
        'Search By', // Action Name
        'Search Page', // label
        {
            value: [filters],
        });
    }
    function searchPageView() {
        const searchPageProps = getSearchPageProps();
        const filters = {};
        if ($rootScope.isEntryPage) {
            const facetCategories = [];
            const searchTextNormalized = SearchUtil.getSearchText().replace(/%20/g, ' ');
            if (!!searchTextNormalized) {
                filters.searchText = searchTextNormalized;
            }
            const facetsByType = {};
            //loop through facet map properties (corresponds to facet categories)
            angular.forEach(mappings.asset, (assetMap) => {
                if (!!assetMap.tracked) {
                    const facet = FacetService.getFacetByFacetName(assetMap.label);
                    const selectedOptions = [];
                    if (facet && facet.selectedOptions && facet.selectedOptions.length) {
                        // loop through selected facets within this category
                        // and save them to selectedOptions array
                        angular.forEach(facet.selectedOptions, function (option) {
                            selectedOptions.push(option.optionName.replace(delimiter, ''));
                        });
                        facetsByType[assetMap.label] = selectedOptions;
                    }
                    if (selectedOptions.length) {
                        facetCategories.push(assetMap.label);
                    }
                }
            });
            if (facetCategories.length) {
                filters.facetTypes = facetCategories;
                filters.facetsByType = facetsByType;
            }
            snowplowUtilsService.trackPageType('Search Page', searchPageProps.pageTypeAlt);
        }
        if (!!filters.facetTypes || !!filters.searchText) {
            logSnowplowSearchCriteria(filters);
        }
    }
    function getLibraryPageProps(type, name) {
        const pageType = 'Library: ' + type;
        return {
            pageName: getUrlPath() + '/' + name,
            pageURL: $location.absUrl(),
            pageType: pageType,
            pageTypeAlt: pageType,
        };
    }
    function libraryPageView(type, name) {
        const libraryPageProps = getLibraryPageProps(type, name);
        snowplowUtilsService.trackPageType('Asset Library Page', libraryPageProps.pageTypeAlt);
    }
    function logSnowplowVideoView(video) {
        return snowplowUtilsService.trackComponent('Video Player', // Component type
        'Video Player', // Component name
        'Metadata Loaded', // Action Name
        'Video Player', // label
        {
            value: [
                {
                    video: video, // pro13
                },
            ],
        });
    }
    function videoView(title) {
        const video = title.replace(/https:\/\/genome-sms\.disney\.com\/results\//g, '');
        logSnowplowVideoView(video);
    }
    function logSnowplowVideoError(error) {
        return snowplowUtilsService.trackComponent('Video Player', // Component type
        'Video Player', // Component name
        'Video Player Error', // Action Name
        'Video Player', // label
        {
            value: [
                {
                    videoError: error, // pro14
                },
            ],
        });
    }
    function videoError(errorCode, errorMessage) {
        let value = '';
        value += deviceDetector.os + ' ' + deviceDetector.os_version;
        value += ', ' + deviceDetector.browser + ' ' + deviceDetector.browser_version;
        value += ', Error Code: ' + errorCode + ' - ' + errorMessage;
        logSnowplowVideoError(value);
    }
}
